import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { ArtistAvatarProps } from './ArtistAvatar.props'
import { getArtistImagePath } from 'shared/utils/getArtistImagePath'

import avatarPath from 'assets/images/artist-default.svg'

import './ArtistAvatar.scss'

const ArtistAvatar: FC<ArtistAvatarProps> = ({ spotifyId, facebookId, className, size, isImage }) => {
  let imagePath = getArtistImagePath(spotifyId, facebookId, size)

  return isImage ? (
    <img
      className={cn('artist-avatar artist-avatar-img', className)}
      src={imagePath || avatarPath}
      alt="Artist avatar"
      onError={() => (imagePath = avatarPath)}
    />
  ) : (
    <div
      className={cn('artist-avatar', className)}
      style={{
        backgroundImage: `url("${imagePath}")`
      }}
    />
  )
}

export default ArtistAvatar
